import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import DataCaptureTable from './components/DataCaptureTable'
import Chart from "../../components/Rechart/Chart";
import http from "../../config/BaseUrl";



const DataCapture = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [eventGraph, setEventGraph] = useState("");

  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get("data-trend-graph/data-capture").then(res => {
        if (res.data.graphData) {
          setIsLoading(false)
          setEventGraph(res.data.graphData)
        }
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {

    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }

  useEffect(() => {
    fetchGraphData()
  }, [])

  return (
    <Layout>
      <div className="page">
        <div className="card radius-10">
          <div className="card-body">

            <Chart
              loading={isLoading}
              graphTotalText={graphTotalText}
              sectionTitle={"Data Collection trends"}
              sectionName={"analytic-capture"}
              dataSet={eventGraph}
              width={1200}
              height={350}
              dataKey={"leads"}
              navClass={"justify-content-end analytic-nav"}
            />

          </div>
        </div>

        <div className="card radius-10">
          <div className="card-body">
            <div className="row">
              <div class="col-12">
                <DataCaptureTable />
              </div>
            </div>

          </div>
        </div>
      </div>

    </Layout>
  );
};

export default DataCapture;
